module.exports = __webpack_public_path__ + "/3b0f51289531cf5d3dc658dc3d01f88f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/clouds_slack.svg
 ** module id = 1637
 ** module chunks = 0
 **/